import { RecordEscrowDisbursementRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateDisbursement = makeValidator({
  FieldParser: RecordEscrowDisbursementRow.omit({ disbursementType: true }),
});
